import { UrlApi } from "../../../../../../services/apirest";

// Mismo comportamiento que getData del original: no valida res.ok.
export const getProductosEnvasados = async () => {
  const response = await fetch(UrlApi + "/productos/envasados");
  return response.json();
};

// Productos envase (id_uso 367). El backend y la app los reconocen por el
// id_uso del producto: el renglón se guarda igual que cualquier otro y el
// valor del envase lo carga el chofer al entregar.
export const getEnvases = async () => {
  const response = await fetch(UrlApi + "/productos/id_uso/367");
  if (!response.ok) {
    throw new Error(`Error HTTP ${response.status} al obtener envases`);
  }
  const data = await response.json();
  // Ante un error SQL este endpoint responde 200 con el objeto de error.
  if (!Array.isArray(data)) {
    throw new Error("Respuesta inválida al obtener envases");
  }
  return data;
};

export const getProductosPredeterminados = async (idDireccion) => {
  const response = await fetch(
    UrlApi + "/envasado_producto_predeterminado/xdir/" + idDireccion,
  );
  if (!response.ok) {
    throw new Error(`Error HTTP ${response.status} al obtener predeterminados`);
  }
  return response.json();
};
